import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function FloatingActionButtons(props) {

    const [isClicked, setIsClicked] = React.useState(false);

    const handleClick = (des, kaf) => (event) => {
        let user;
        var len = props.commentRec.length 

        if (JSON.stringify(props.commentRec).includes("userIdentifier")) {
            user = props.commentRec.at(len - 1).user.userIdentifier;
        }

        if ((user === props.userIdentifier) || (des === "Approved")) {
            props.errorCallback(false);
            setIsClicked(true);

            fetch("/api/commentsweb/" + props.discussRec.discussionIdentifier + "/" + props.userIdentifier, {
                method: "POST",
                headers: {
                    "ClientIdentifier": props.discussRec.loan.clientIdentifier,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify("This document was " + des)
            })
            .then(function (response) {
                console.log(response.status);
                if (!response.ok) {
                    setIsClicked(false);
                    throw new Error("HTTP status " + response.status);
                }

                fetch("/api/kafkaweb/" + kaf + "/" + props.discussRec.discussionIdentifier, {
                    method: "POST",
                    headers: {
                        "ClientIdentifier": props.discussRec.loan.clientIdentifier,
                        "Content-Type": "application/json"
                    }
                })
                .then(function (response) {
                    console.log(response.status);
                    if (!response.ok) {
                        setIsClicked(false);
                        throw new Error("HTTP status " + response.status);
                    }

                    fetch("/api/discussionweb/" + props.discussRec.discussionIdentifier, {
                        method: "PUT",
                        headers: {
                            "ClientIdentifier": props.discussRec.loan.clientIdentifier,
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            "IsDecisioned": true
                        })
                    })
                    .then(function (response) {
                        console.log(response.status);
                        if (!response.ok) {
                            setIsClicked(false);
                            throw new Error("HTTP status " + response.status);
                        }
                        setIsClicked(true);
                        props.decisionCallback();
                    })
                })
            })   
        }
        else {
            props.errorCallback(true);
        }       
    };

    if (props.userType === 'attorney') {
        return (
            <Box sx={{ '& > :not(style)': { m: 4 } }}>
                <div>
                    <Button
                        fullWidth
                        id="accept"
                        variant="contained"
                        color="primary"
                        aria-label="accept"
                        onClick={handleClick("Approved", "accept")}
                        disabled={isClicked || props.discussRec.isDecisioned || !props.docLoaded}
                        >APPROVE DOCUMENT
                    </Button>
                </div>
                <div>
                    <Button
                        fullWidth
                        id="reject"
                        variant="outlined"
                        aria-label="reject"
                        onClick={handleClick("Rejected", "reject")}
                        disabled={isClicked || props.discussRec.isDecisioned || !props.docLoaded}
                        >REJECT DOCUMENT
                    </Button>
                </div>
            </Box>
        );
    } 
}